import {
  EntitlementsInterface,
  EntitlementsInterfaceInitType
} from './EntitlementsInterface';
import { EntitlementsInterfaceType } from './types';

let entitlementsInterface: EntitlementsInterface;

export function getEntitlementsInterface(): EntitlementsInterface {
  return entitlementsInterface;
}

/**
 * Initialize the Entitlements interface
 *
 * @param options - Configuration for Entitlements
 * @returns Entitlements interface object
 */
export default async function initializeEntitlementsInterface({
  authProvider,
  events,
  entitlementsInput
}: EntitlementsInterfaceInitType): Promise<EntitlementsInterfaceType> {
  if (entitlementsInterface) return entitlementsInterface.getInterface();

  // Create an instance of the new EntitlementsInterface class
  entitlementsInterface = new EntitlementsInterface({
    authProvider,
    events,
    entitlementsInput
  });

  // Return the interface methods
  return entitlementsInterface.getInterface();
}
